import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { logout } from "../../../redux/actions/logoutAction";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { Row, Col } from "react-bootstrap";

import * as helper from "../../../utils/helper";
import * as API from "../../../utils/apis";

import BoxCard from "../../../components/BoxCard";
import InputSelect from "../../../components/InputSelect";
import Breadcrumb from "../../../components/Breadcrumb";
import InputText from "../../../components/InputText";
import DataTable from "../../../components/DataTable";
import DataTableNodata from "../../../components/DataTableNodata";

const MySwal = withReactContent(Swal);

function UserView() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.login.result);
  const statusCheck = useSelector((state) => state.statusCheck);
  const breadcrumbPath = [
    { path: "/home", name: "หน้าหลัก" },
    {
      path: "/data-manage/web-settings/news",
      name: "บริหารจัดการข้อมูลส่วนกลาง",
    },
    { path: "/data-manage/users/users", name: "ผู้ใช้งาน" },
    { path: "active", name: "รายการสิทธิการดูข้อมูล" },
  ];

  const initialForm = {
    userViewId: "",
    statusId: "",
    name: "",

    limit: 10,
    page: 1,
    totalPages: 1,
    sortDir: "DESC",
    sortBy: "id",
    totalElements: 0,
    numberOfElements: 0,

    headTitle: [
      {
        name: "ลำดับ",
        sortFlg: false,
        width: "50px",
      },
      {
        sortBy: "name",
        name: "ชื่อสิทธิการดูข้อมูล",
        sortFlg: true,
      },
      {
        sortBy: "description",
        name: "รายละเอียด",
        sortFlg: true,
      },
      {
        sortBy: "statusId",
        name: "สถานะ",
        sortFlg: true,
      },
      {
        sortBy: "updateDate",
        name: "ปรับปรุงล่าสุด",
        sortFlg: true,
      },
      {
        name: "จัดการ",
        sortFlg: false,
      },
    ],
  };

  const [form, setForm] = useState(initialForm);

  const [listUserView, setListUserView] = useState([]);
  const [isClearSearch, setIsClearSearch] = useState(false);

  const [statusSelectValue, setStatusSelectValue] = useState([]);
  const selectStatusList = [
    { value: 1, label: "ใช้งาน" },
    { value: 2, label: "ไม่ใช้งาน" },
  ];
  const [statusList, setStatusList] = useState(selectStatusList);

  useEffect(async () => {
    await getUserView();
  }, [form.limit, form.page, form.sortBy, form.sortDir, isClearSearch]);

  const getUserView = async () => {
    try {
      const response = await API.getUserView(
        form.userViewId,
        form.statusId,
        form.name,
        form.page,
        form.limit,
        form.sortBy,
        form.sortDir
      );
      const data = await response?.data;
      if (response.status === 200) {
        let userViewArray = [];
        data.content.forEach((element) => {
          userViewArray.push({
            value: element.id,
            label: element.name,
          });
        });

        setForm({
          ...form,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          numberOfElements: data.numberOfElements,
        });
        setListUserView(data.content);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(logout({ history }));
      }
      console.log(error);
    }
  };

  const getStatusColor = (idStatus) => {
    let statusColor;
    if (statusCheck && statusCheck.length > 0) {
      statusCheck.map((item) => {
        if (item.id === idStatus) {
          statusColor = (
            <div className="d-flex justify-content-center">
              <div
                style={{ background: item.color }}
                className="box-status font14 px-4 text-center text-white"
              >
                <span>{item.status}</span>
              </div>
            </div>
          );
        }
      });
    }
    return statusColor;
  };

  const getFilter = (type, isChange1, isChange2) => {
    if (type === "page") {
      setForm({
        ...form,
        page: isChange1,
      });
    } else if (type === "limit") {
      setForm({
        ...form,
        page: 1,
        limit: isChange1,
      });
    } else if (type === "filter") {
      setForm({
        ...form,
        sortBy: isChange1,
        sortDir: isChange2,
        page: 1,
      });
    }
  };

  const buttonAddUserView = () => {
    return (
      <button
        className="btn btn-info "
        disabled={user?.userGroup.mcreate === "n"}
        onClick={() =>
          history.push(`/data-manage/users/view-user/save-user-view`)
        }
      >
        <div className="text-white">
          <i className="fas fa-plus mr-1 "></i>เพิ่มสิทธิการดูข้อมูล
        </div>
      </button>
    );
  };

  const buttonSearch = () => {
    return (
      <>
        <button className="btn btn-danger mr-2" onClick={() => clearSearch()}>
          ล้างข้อมูล
        </button>

        <button className="btn btn-success" onClick={() => toSearch()}>
          ค้นหา
        </button>
      </>
    );
  };

  const delUserView = async (id) => {
    MySwal.fire({
      text: `ยืนยันที่จะลบข้อมูลผู้ใช้งาน`,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await API.deleteUserView(id);
          if (response.status === 200) {
            await getUserView();
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const editUserView = (id) => {
    history.push(`/data-manage/users/view-user/edit/${id}`);
  };

  const toSearch = () => {
    setForm({ ...form, page: 1 });
    setIsClearSearch(!isClearSearch);
  };

  const clearSearch = () => {
    setForm(initialForm);
    setStatusSelectValue([]);
    setIsClearSearch(!isClearSearch);
  };

  const renderTableUserView = (data) => {
    if (data.length > 0) {
      return data.map((item, i) => (
        <tr key={i} className="text-center">
          <td>{form.limit * (form.page - 1) + (i + 1)}</td>
          <td>{item.name ? item.name : "-"}</td>
          <td>{item.description ? item.description : "-"}</td>
          <td>{item.statusId ? getStatusColor(item.statusId) : "-"}</td>
          <td>
            <h6 className="mb-0">
              {item.updateDate
                ? helper.momentDate(item.updateDate, "th", "short")
                : "-"}
            </h6>
            <h6>
              {item.updateDate ? helper.getTime(item.updateDate, "th") : ""}
            </h6>
          </td>
          <td>
            <div className="d-flex justify-content-center ">
              <button
                className="btn btn-add mr-2 "
                onClick={() => editUserView(item.id)}
                disabled={
                  user?.userGroup.mupdate === "n" &&
                  user?.userGroup.mview === "n"
                }
              >
                <img className="icon-btn " src="/svg/btn-edit.svg" alt="edit" />
              </button>
              <button
                className="btn btn-del mr-2 "
                onClick={() => delUserView(item.id)}
                disabled={user?.userGroup.mdelete === "n"}
              >
                <img className="icon-btn " src="/svg/btn-del.svg" alt="del" />
              </button>
            </div>
          </td>
        </tr>
      ));
    } else {
      return <DataTableNodata colSpan={6} />;
    }
  };
  return (
    <div className=" ">
      <div className="pl-4 bg-white ml30 d-flex ">
        <div className="mr-auto p-2 ">
          <Breadcrumb data={breadcrumbPath} />
        </div>
      </div>
      <div className="bg-gray-light">
        <div className="px-4 pt-3 container-fixed-footer">
          <BoxCard classNameBox="" title="ตัวกรอง" headRight={buttonSearch()}>
            <Row>
              <Col lg={2} md={4} sm={6} xs={6}>
                <InputText
                  title="ชื่อสิทธิการดูข้อมูล"
                  star={false}
                  placeholder="โปรดระบุ"
                  value={form.name}
                  classLabel="normal"
                  handleChange={(value) => setForm({ ...form, name: value })}
                />
              </Col>

              <Col lg={2} md={4} sm={6} xs={6}>
                <InputSelect
                  title="สถานะ"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="status"
                  classLabel="normal"
                  selectValue={statusSelectValue}
                  optionsList={statusList}
                  handleChange={(value) => {
                    setForm({ ...form, statusId: value.value });
                    setStatusSelectValue(value);
                  }}
                />
              </Col>
            </Row>
          </BoxCard>

          <BoxCard
            title="รายการสิทธิการดูข้อมูล"
            classNameBox="mt-4"
            headRight={buttonAddUserView()}
          >
            <DataTable
              headColumns={form.headTitle}
              totalPages={form.totalPages}
              page={form.page}
              limit={form.limit}
              sortDir={form.sortDir}
              sortBy={form.sortBy}
              getLimit={(limit) => getFilter("limit", limit)}
              getFilter={(sortBy, sortDir) =>
                getFilter("filter", sortBy, sortDir)
              }
              getPage={(page) => getFilter("page", page)}
              totalItems={form.totalElements}
              numberOfItems={form.numberOfElements}
              isClear={isClearSearch}
            >
              {renderTableUserView(listUserView)}
            </DataTable>
          </BoxCard>
        </div>
      </div>
    </div>
  );
}

export default UserView;
